export default "__VITE_ASSET__BkoEjWmh__"